import {Provider} from "../../model/providers";
import {Action, createReducer, on} from "@ngrx/store";
import {providersActions, polygonActions} from "../actions";

export interface State {
  bkPolygonData: any;
}

export const initialState: State = {
  bkPolygonData: null
}

const polygonsReducer = createReducer(initialState,
  on(polygonActions.bkPolygonData, (state, action) => {
    return {
      ...state,
      bkPolygonData: action.polygonsFC
    };
  }),
  on(polygonActions.nukeBkPolygonData, (state, action) => {
    return {
      ...initialState
    };
  }),
);

export function reducer(state: State | undefined, action: Action): any {
  return polygonsReducer(state, action);
}
